import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Box, Container, Snackbar } from '@mui/material';

import { CONSTANTS, STRINGS } from 'src/commons';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import Toolbar from 'src/components/payments/Toolbar';
import { paymentReducerAction } from 'src/redux/reducers/payment';
import { deletePayment, getPayment } from 'src/api/payment';
import PaymentResultList from 'src/components/payments/PaymentResultList';
import ConfirmDialog from 'src/components/ConfirmationBox';

const Payment = () => {
  const location = useLocation();
  const member_id = location?.pathname?.split('/')?.pop();
  const { startLoading, stopLoading } = loaderReducerAction;
  const [payment, setPayment] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.common);
  const { updatePayments } = paymentReducerAction;
  const { logoutUser } = commonReducerAction;
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteMemberData, setDeleteMemberData] = useState({});
  const [deleting, setDeleting] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  useEffect(() => {
    dispatch(startLoading());
    getPayment(user, member_id)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setPayment(res.data);
          dispatch(updatePayments(res.data));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEdit = (item) => {
    navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.EDIT_PAYMENT + '/' + item._id);
  };
  const onDelete = (item) => {
    dispatch(startLoading());
    deletePayment(user, item._id)
      .then(() => {
        setDeleting(true);
        getPayment(user, member_id)
          .then((res) => {
            if (res?.status === 200) {
              setSnackbarState({
                open: true,
                message: 'Payment deleted successfully',
                severity: 'success'
              });
            } else if (res?.status !== 200) {
              setSnackbarState({
                open: true,
                message: res?.message || 'Something went wrong',
                severity: 'error'
              });
            }
            setDeleting(false);
            setDeleteModal(false);
            if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) logoutUser();
            if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
              setPayment(res.data);
              dispatch(updatePayments(res.data));
            }
            dispatch(stopLoading());
          })
          .catch((err) => {
            setSnackbarState({
              open: true,
              message: err?.message || 'Something went wrong',
              severity: 'error'
            });
            dispatch(stopLoading());
            setDeleting(false);
            setDeleteModal(false);
          });
      })
      .catch((err) => {
        setSnackbarState({
          open: true,
          message: err?.message || 'Something went wrong',
          severity: 'error'
        });
        dispatch(stopLoading());
        setDeleting(false);
        setDeleteModal(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Payment | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            text={STRINGS.ADD_PAYMENT}
            route={
              CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_PAYMENT + '/' + member_id
            }
          />
          <Box sx={{ pt: 3 }}>
            <PaymentResultList
              payments={payment}
              onEdit={onEdit}
              onDelete={(item) => {
                setDeleteMemberData(item);
                setDeleteModal(true);
              }}
            />
          </Box>
        </Container>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
      <ConfirmDialog
        heading={'Delete  Payment'}
        message={'Do you want to delete the payment?'}
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false);
        }}
        handleConfirm={() => {
          onDelete(deleteMemberData);
        }}
        loading={deleting}
        key={'detete modal'}
      />
    </>
  );
};

export default Payment;
